export function registerGeneralWidgets() {
    // No general widgets currently
}
